import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { webRequest } from './api';
import { useAppNavigate } from './impersonation';
import { useSourceOpener } from './WorkspaceCoach';
import { ResultsScreen } from '../../shared/src/screens/ResultsScreen';
import { PeopleScreen } from '../../shared/src/screens/PeopleScreen';
import { resultCatalog } from '../../shared/src/results/catalog';
import { httpPeopleClient, httpResultsClient } from '../../shared/src/utils/httpClients';

interface ScreenProps {
  token: string;
  /** The result or person in the address bar, if one is open. */
  selected: string | null;
  canOpenSources: boolean;
}

export function WorkspaceResults({ token, selected, canOpenSources }: ScreenProps) {
  const navigate = useAppNavigate();
  const openSource = useSourceOpener(canOpenSources);
  const justUnlocked = new URLSearchParams(useLocation().search).has('unlocked');
  const client = useMemo(
    () =>
      httpResultsClient(webRequest(token), {
        openCheckout: (url) => window.location.assign(url),
        openSource,
      }),
    [token, openSource]
  );
  return (
    <div className="workspace-pane">
      <ResultsScreen
        client={client}
        selected={resultCatalog.find((result) => result.id === selected)?.id ?? null}
        onSelect={(id) => navigate(id ? `/app/results/${id}` : '/app/results')}
        onConnect={() => navigate('/app/settings')}
        justUnlocked={justUnlocked}
        imageBaseUrl=""
      />
    </div>
  );
}

export function WorkspacePeople({ token, selected, canOpenSources }: ScreenProps) {
  const navigate = useAppNavigate();
  const openSource = useSourceOpener(canOpenSources);
  const client = useMemo(
    () => httpPeopleClient(webRequest(token), openSource),
    [token, openSource]
  );
  return (
    <div className="workspace-pane">
      <PeopleScreen
        client={client}
        selected={selected}
        onSelect={(edgeId) =>
          navigate(edgeId ? '/app/people/' + encodeURIComponent(edgeId) : '/app/people')
        }
        onConnect={() => navigate('/app/settings')}
      />
    </div>
  );
}
